/**
 * CarPoolsVehicleDetails
 * Handles all JS stuff for vehicle examination detail page
 */
export default class CarPoolsVehicleExaminations {

    // constructor
    constructor(selector) {

        let _this = this;
        this.$plugin = $(selector);

        // cancel if non existing element
        if (this.$plugin.length === 0) {
            return false;
        }
        this.$result = this.$plugin.find('[data-tncp-vehicleexaminationslist="results"]');

        if (this.$result.length > 0) {
            this.execute();
        }
    }

    // get results
    getResults() {
        let vm = this;
        let $form = this.$plugin.find('[data-tncp-vehicleexaminationslist="filterForm"]');
        let serializedFilters = btoa($form.serialize());
        const formData = new FormData();
        return new Promise(function(resolve, reject) {
            formData.append("tx_tuevnordcustomerportal_api[filter]", serializedFilters);

            vm.$plugin.find('[data-form--isloading]').attr('data-form--isloading', 'true');

            vm.request = window.xhrRequest({
                url: $form.attr('action'),
                method: 'POST',
                data: formData
            });
            vm.request.then((response) => {
                vm.$result.html(response.data.content);
                vm.$plugin.find('[data-form--isloading]').attr('data-form--isloading', 'false');
                resolve(response);
            });
            vm.request.catch((e) => {
                reject(e);
            });
        });
    }

    // execute
    execute() {
        let vm = this;

        // on page load
        vm.getResults();

        // on form submit
        vm.$plugin.on('submit', '[data-tncp-vehicleexaminationslist="filterForm"]', () => {
            vm.$plugin.find('[data-tncp-pagination-value]').val(''); // resets the pagination on filter change
            vm.getResults();
            return false;
        });

    }
}
